// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle {\n  text-align: center;\n  font-size: 1.1rem;\n  margin-top: 0.5rem;\n}", ""]);
// Exports
module.exports = exports;
